export default {
  buttons: {
    skip: 'Skip',
    back: 'Back',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
    payment: {
      pending: 'Your payment is currently being processed...',
      success: '👍 Your payment was processed successfully. Thank you!',
      error:
        '⁉️There was a problem with your payment or the processing is taking longer than expected. Please try to refresh the page for 1 minute, otherwise contact tech support.',
    },
  },
};
